/**
 * 경로(LineString)를 일정 간격으로 샘플링하는 순수 유틸 함수
 * Pathgenerate 자동 경로 저장 로직에서 분리
 */

/**
 * 좌표 배열을 구간별로 interval 간격으로 샘플링
 * @param {Array<[number, number]>} coordinates - [x, y] 쌍 배열
 * @param {number} interval - 샘플 간격 (기본 1.0)
 * @param {number} zBase - z 좌표 값 (기본 0)
 * @returns {Array<{x, y, z, sequence}>}
 */
export function sampleLineStringAtInterval(
  coordinates,
  interval = 1.0,
  zBase = 0,
) {
  const result = [];

  let sequence = 0;

  for (let i = 0; i < coordinates.length - 1; i++) {
    const [x1, y1] = coordinates[i];
    const [x2, y2] = coordinates[i + 1];

    const dx = x2 - x1;
    const dy = y2 - y1;

    const segmentLength = Math.sqrt(dx * dx + dy * dy);

    // 구간을 몇 등분할지 결정
    const steps = Math.max(1, Math.floor(segmentLength / interval));

    for (let step = 0; step <= steps; step++) {
      const t = step / steps; // 0~1 비율

      const x = x1 + dx * t;
      const y = y1 + dy * t;

      result.push({
        x,
        y,
        z: zBase,
        sequence: sequence++,
      });
    }
  }

  return result;
}

/**
 * fullPathStore(GeoJSON FeatureCollection) 전체를 interval 간격으로 샘플링
 * @param {Object} fullPathStore - features 배열을 가진 객체 (GeoJSON FeatureCollection)
 * @param {number} interval - 샘플 간격 (기본 1.0)
 * @param {number} zBase - z 좌표 기준값 (기본 0, 호출부에서 minZ 등으로 설정)
 * @returns {Array<{x, y, z, sequence}>}
 */
export function sampleFullPath(fullPathStore, interval = 1.0, zBase = 0) {
  const waypoints = [];
  let seq = 0;

  fullPathStore.features.forEach((feature) => {
    if (feature.geometry.type !== "LineString") return;

    const coords = feature.geometry.coordinates;

    const sampled = sampleLineStringAtInterval(coords, interval, zBase);

    sampled.forEach((pt) => {
      pt.sequence = seq++;
      waypoints.push(pt);
    });
  });

  return waypoints;
}
